import { createSafeContext } from '@/util';

import type { VBaseSelectContextValue } from './type';

const VBaseSelectContext = createSafeContext<VBaseSelectContextValue>();

export default VBaseSelectContext;
